import { render, staticRenderFns } from "./PutOnHoldModal.vue?vue&type=template&id=1e796abe&scoped=true"
import script from "./PutOnHoldModal.vue?vue&type=script&lang=js"
export * from "./PutOnHoldModal.vue?vue&type=script&lang=js"
import style0 from "./PutOnHoldModal.vue?vue&type=style&index=0&id=1e796abe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e796abe",
  null
  
)

export default component.exports